import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from 'components';
import { Button } from '@mui/material';
import * as icons from 'mdi-material-ui';

const FileInputButton = ({
    label,
    onFileChange,
    className,
    buttonClassName,
    showIcon,
    id = 'icon-button-file',
    disabled,
    loading,
    acceptedFileTypes = '.pdf, .docx, .jpeg, .jpg, .png',
    noMargin,
    sx,
    multiple,
    ...rest
}) => {
    return (
        <Button
            variant="outlined"
            htmlFor={id}
            disableRipple
            disabled={disabled || loading}
            className={buttonClassName}
            sx={theme => ({
                [theme.breakpoints.down('sm')]: { width: '100%' },
                marginRight: noMargin ? 0 : '20px',
                marginLeft: noMargin ? 0 : '20px',
                borderRadius: '5px',
                padding: '10px',
                minWidth: '130px',
                ...(typeof sx === 'function' ? sx(theme) : sx),
            })}
            component="label"
            endIcon={showIcon && <icons.PlusCircle />}
            {...rest}
        >
            <Loader loading={loading} size={20} marginTop={0}>
                {label}
            </Loader>
            <input
                hidden
                id={id}
                name={id}
                value=""
                onChange={onFileChange}
                accept={acceptedFileTypes}
                disabled={disabled}
                multiple={multiple}
                type="file"
            />
        </Button>
    );
};

FileInputButton.propTypes = {
    label: PropTypes.node,
    onFileChange: PropTypes.func,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    acceptedFileTypes: PropTypes.string,
    disabled: PropTypes.bool,
    noMargin: PropTypes.bool,
    showIcon: PropTypes.bool,
    loading: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default FileInputButton;
